import { helper } from '@ember/component/helper';

export default helper(function today() {
  return new Date();
});
